export const PK_TIME_ZONE = 'Asia/Karachi';

/** Calendar day in Pakistan (YYYY-MM-DD). */
export function pkTodayKey(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: PK_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const y = parts.find((p) => p.type === 'year')?.value;
  const m = parts.find((p) => p.type === 'month')?.value;
  const d = parts.find((p) => p.type === 'day')?.value;
  if (y && m && d) return `${y}-${m}-${d}`;
  return now.toISOString().slice(0, 10);
}

export function pkTodayRange() {
  const today = pkTodayKey();
  return { startDate: today, endDate: today };
}
